var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fd-iframe-module"},[_c('iframe',_vm._b({style:(_vm.style),attrs:{"frameborder":"0","scrolling":"no"}},'iframe',_vm.attributes,false))])}
var staticRenderFns = []

export { render, staticRenderFns }